<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-row no-gutters>
      <v-col cols="12">
        <DxDataGrid
          id="dxDataGrid"
          width="100%"
          height="60%"
          ref="grid"
          :data-source="gridData"
          :remote-operations="false"
          :hover-state-enabled="false"
          :allow-column-reordering="false"
          :allow-column-resizing="true"
          :allow-sorting="false"
          :row-alternation-enabled="false"
          :column-auto-width="false"
          :show-borders="true"
          :show-row-lines="true"
          :selection="{ mode: 'single' }"
          key-expr="minorCd"
          :focused-row-enabled="true"
          :paging="{ enabled: false }"
        >
          <DxPager :visible="false" />
          <DxColumn
            data-field="minorNm"
            data-type="string"
            width="150px"
            alignment="center"
            caption="상태명"
            :allow-editing="false"
            :allow-sorting="false"
          />
          <DxColumn
            data-field="extra1"
            data-type="string"
            width="100px"
            alignment="center"
            caption="행위주최"
            :allow-editing="false"
            :allow-sorting="false"
          />
          <DxColumn
            data-field="extra2"
            data-type="string"
            width="100px"
            alignment="center"
            caption="변경주최"
            :allow-editing="false"
            :allow-sorting="false"
          />
          <DxColumn
            data-field="remark"
            data-type="string"
            width="400px"
            alignment="left"
            caption="동작"
            :allow-editing="false"
            :allow-sorting="false"
          />
        </DxDataGrid>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

import iDxPopup from '@/components/common/iDxPopup.vue'
import { getCommonCode } from '@/api/common/commonApi'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'taxInvoiceStausPopup',
  components: {
    'i-dxpopup': iDxPopup
  },
  data() {
    return {
      gridData: []
    }
  },
  computed: {},
  beforeMount() {},
  activated() {},
  created() {
    this.initApi()
  },
  mounted() {},
  methods: {
    initApi() {
      getCommonCode('TAX001').then(res => {
        this.gridData = res.list
      })
    }
  }
}
</script>

<style scoped></style>
